import { SignIn } from "@clerk/clerk-react";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/sign-in")({
	component: SignInPage,
});

function SignInPage() {
	return (
		<div className="min-h-screen bg-base-200 flex items-center justify-center p-4">
			<SignIn routing="hash" />
		</div>
	);
}
